import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useMeContext } from '~/modules/me';

const useSetSearchCriteriaEffect = ({ setSearchCriteria }) => {
  const {
    featureFlags: { isPsaRmpSkillAnalyticsEnabled }
  } = useMeContext();

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (
      isPsaRmpSkillAnalyticsEnabled &&
      location?.state?.searchCriteria &&
      setSearchCriteria
    ) {
      setSearchCriteria(location.state.searchCriteria);

      history.replace({
        pathname: location.pathname,
        state: undefined
      });
    }
  }, [isPsaRmpSkillAnalyticsEnabled, location, setSearchCriteria, history]);
};

export default useSetSearchCriteriaEffect;
